import create from 'zustand'
import { devtools } from 'zustand/middleware'

import { API_BASE_URL, client } from 'App'


export const authInitialData = {
  data: {},
  isLogged: null,
  isFetching: false,
}

let intervalCheckAuth = null

const useAuthStore = create(devtools(
  (set, get) => ({
    ...authInitialData,
    signup: async (email, password1, password2, data = {}) => {
      const request = await fetch(
        API_BASE_URL + 'account/registration/',
        {
          headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
          },
          method: 'POST',
          body: JSON.stringify({
            data: {
              type: 'RegisterView',
              attributes: {
                ...data,
                email,
                password1,
                password2,
                username: email,
              },
            },
          })
        }
      )
      let response = await request.json()
      return response
    },
    confirmAccount: async (key) => {
      await fetch(
        API_BASE_URL + 'account/registration/verify-email/',
        {
          headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
          },
          method: 'POST',
          body: JSON.stringify({
            data: {
              type: 'VerifyEmailView',
              attributes: {
                'key': key,
              },
            },
          })
        }
      )
    },
    logout: () => {
      get().setUser({}, false, false)
      clearInterval(intervalCheckAuth)
      localStorage.removeItem('improvisaToken')
    },
    login: async (email, password) => {
      const request = await fetch(
        API_BASE_URL + 'token/',
        {
          headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
          },
          method: 'POST',
          body: JSON.stringify({
            data: {
              type: 'TokenObtainPairView',
              attributes: {
                email: email,
                password: password,
              },
            },
          })
        }
      )
      const response = await request.json()
      return response
    },
    checkAuth: async () => {
      const request = await fetch(
        API_BASE_URL + 'token/verify/',
        {
          headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
          },
          method: 'POST',
          body: JSON.stringify({
            data: {
              type: 'TokenVerifyView',
              attributes: {
                token: localStorage.getItem('improvisaToken'),
              },
            },
          })
        }
      )
      const response = await request.json()
      if (response.errors || response.error) {
        clearInterval(intervalCheckAuth)
        get().logout()
      }

    },
    resetPassword: async (email) => {
      const request = await fetch(
        API_BASE_URL + 'account/password/reset/',
        {
          headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
          },
          method: 'POST',
          body: JSON.stringify({
            data: {
              type: 'PasswordResetView',
              attributes: {
                'email': email,
              },
            },
          })
        }
      )
      const response = await request.json()
      return response
    },
    changePassword: async (token, uid, new_password1, new_password2) => {
      const request = await fetch(
        API_BASE_URL + 'account/password/reset/confirm/',
        {
          headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
          },
          method: 'POST',
          body: JSON.stringify({
            data: {
              type: 'PasswordResetConfirmView',
              attributes: {
                token,
                uid,
                new_password1,
                new_password2,
              },
            },
          })
        }
      )
      const response = await request.json()
      return response
    },
    setUser: (data, isLogged, isFetching) => {
      set({
        data,
        isLogged,
        isFetching,
      })
    },
    getUser: async () => {
      get().setUser({}, null, true)

      const { data, error } = await client.fetch('users/me?include=profile_pic')

      if ( ! error) {
        get().setUser(data, true, false)
        if (intervalCheckAuth) {
          clearInterval(intervalCheckAuth)
        }
        intervalCheckAuth = setInterval(() => {
          get().checkAuth()
        }, 90000)

      } else {
        get().logout()

      }
    }
  }
)))

export default useAuthStore
